export const DEV_TUNNEL_ACCESS_TOKEN_PARAM = "forgeTunnelToken";

export interface DevTunnelUrlMetadata {
  readonly tunnelId?: string;
  readonly localPort?: number;
  readonly expiresAt?: string;
}

function decodeBase64UrlJson(input: string): unknown {
  const normalized = input.replaceAll("-", "+").replaceAll("_", "/");
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
  return JSON.parse(globalThis.atob(padded)) as unknown;
}

export function devTunnelIdFromUrl(input: string | null | undefined): string | null {
  if (!input) {
    return null;
  }
  try {
    const url = new URL(input);
    const match = /^\/api\/dev-tunnel\/([^/]+)/u.exec(url.pathname);
    return match?.[1] ?? null;
  } catch {
    return null;
  }
}

export function readDevTunnelUrlClaims(
  input: string | null | undefined,
): DevTunnelUrlMetadata | null {
  if (!input) {
    return null;
  }
  try {
    const token = new URL(input).searchParams.get(DEV_TUNNEL_ACCESS_TOKEN_PARAM);
    const [, payload] = token?.split(".") ?? [];
    if (!payload) {
      return null;
    }
    const claims = decodeBase64UrlJson(payload);
    if (!claims || typeof claims !== "object") {
      return null;
    }
    const record = claims as {
      readonly tunnelId?: unknown;
      readonly localPort?: unknown;
      readonly expiresAt?: unknown;
    };
    return {
      ...(typeof record.tunnelId === "string" ? { tunnelId: record.tunnelId } : {}),
      ...(typeof record.localPort === "number" ? { localPort: record.localPort } : {}),
      ...(typeof record.expiresAt === "string" ? { expiresAt: record.expiresAt } : {}),
    };
  } catch {
    return null;
  }
}

export function devTunnelDisplayUrl(
  input: string | null | undefined,
  metadata: DevTunnelUrlMetadata | null | undefined = readDevTunnelUrlClaims(input),
): string | null {
  if (!input) {
    return null;
  }
  try {
    const url = new URL(input);
    if (!url.pathname.startsWith("/api/dev-tunnel/")) {
      return input;
    }
    if (!metadata?.localPort) {
      return input;
    }
    const match = /^\/api\/dev-tunnel\/[^/]+\/?(.*)$/u.exec(url.pathname);
    const subpath = match?.[1] ?? "";
    const display = new URL(`http://localhost:${metadata.localPort}/`);
    display.pathname = subpath ? `/${subpath}` : "/";
    for (const [key, value] of url.searchParams.entries()) {
      if (key !== DEV_TUNNEL_ACCESS_TOKEN_PARAM) {
        display.searchParams.append(key, value);
      }
    }
    display.hash = url.hash;
    return display.toString();
  } catch {
    return input;
  }
}
